(async section_name=>{
    [
        ()=>{
            //variant picker
            const variantPicker=document.querySelector(`.${section_name}_variant_picker_wrapper`);
            const variantPickerAnchor = document.querySelector(`.${section_name} .product-info__block-list>div:nth-child(5)`);
            const productForm=document.querySelector(`.${section_name} .product-info__block-item form.shopify-product-form`);
            if (!variantPicker || !variantPickerAnchor || !productForm) return;
            const productStickyBarPrice=document.querySelector(`.${section_name} product-sticky-bar[form] price-list`);
            variantPickerAnchor.insertAdjacentElement("afterend",variantPicker);
            variantPicker.addEventListener('change',({target})=>{
                if (!target?.checked) return;
                const {price, id, selling_plan} = target.dataset;
                if (!price || !id) return;
                if (productStickyBarPrice) productStickyBarPrice.innerHTML=`<sale-price class="text-subdued"><span class="sr-only">Salgspris</span>${price}</sale-price>`;
                let productFormSellingPlan=productForm.querySelector(`input[name="selling_plan"]`);
                if (selling_plan) {
                    if (!productFormSellingPlan) {
                        productFormSellingPlan = Object.assign(document.createElement("input"),{
                            name: "selling_plan",
                            type: "hidden",
                            value: selling_plan
                        });
                        productForm.prepend(productFormSellingPlan);
                    } else productFormSellingPlan.value=selling_plan;
                } else productFormSellingPlan?.remove();
                let productFormVariantId=productForm.querySelector(`input[name="id"]`);
                if (!productFormVariantId) {
                    productFormVariantId = Object.assign(document.createElement("input"),{
                        name: "id",
                        type: "hidden",
                        value: id
                    });
                    productForm.prepend(productFormVariantId);
                } else productFormVariantId.value=id;
                productForm.dispatchEvent(new Event("change"));
            });
            variantPicker.querySelector('input:checked')?.dispatchEvent(new Event("change",{bubbles: !0}));
        },
        ()=>{
            // accordion
            document.querySelector(`.${section_name} [data-block-type="accordion"] details summary`)?.click();
        },
        ()=>{
            // USP
            const uspWrapper=document.querySelector(`.${section_name}_usp_wrapper`);
            const uspWrapperAnchor=document.querySelector(`.${section_name} .product-info__block-list>div:last-child`);
            if (!uspWrapper || !uspWrapperAnchor) return;
            uspWrapperAnchor.insertAdjacentElement("afterend",uspWrapper);
        }
    ].forEach(fn=>{try {fn()} catch(e){console.log}});
})("acc-st-product-101_01").catch(console.info);
